import { MerchantsTable } from '../components/MerchantsTable';

export const Merchants = () => {
  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-xl font-semibold text-gray-900">Vendors</h1>
      <MerchantsTable />
    </div>
  );
};
